<script setup lang="ts">
	import { MzNavbar } from '@monizze/monizze-components';
	import Logout from '@/pages/Logout.vue';
	import { useI18n } from 'vue-i18n';
	import { useAuthStore } from '@/stores/auth.ts';
	import { detectedLanguage } from '@/main.ts';
	import { useTitle } from '@vueuse/core';

	const getLogo = (): string => {
		return window.location.host.includes('up-luxembourg') ? '/up_luxembourg_logo.svg' : '/monizze_logo.svg';
	};

	const { fallbackLocale, locale, t } = useI18n();
	const pinia = useAuthStore();
	const availableLanguages: string[] = pinia.isLux ? ['fr_LU', 'en_LU'] : ['fr', 'nl', 'en'];
	const defaultLocale = pinia.isLux ? 'fr_LU' : 'nl';

	useTitle(t('head.title'));

	const updateLocale = (newLocale: string): void => {
		locale.value = newLocale;
		if (pinia.isLux) {
			fallbackLocale.value = newLocale.substring(0, 2);
		}
	};

	// Setup default language
	const selectedLanguage = availableLanguages.includes(detectedLanguage) ? detectedLanguage : defaultLocale;
	locale.value = selectedLanguage;
</script>

<template>
	<mz-navbar
		:current-lang="locale.substring(0, 2)"
		:allowed-lang="availableLanguages"
		class="absolute w-full lg:px-40 sm:px-12"
		:logo-url="getLogo()"
		@change-lang="updateLocale"
	>
		<template #login>
			<logout></logout>
		</template>
	</mz-navbar>
	<router-view />
</template>
